import { TransactionQueryKeys } from '@/modules/transaction/keys'
import {
	SearchUsersForRematchParams,
	SearchUsersForRematchResponse,
} from '@/modules/transaction/types'
import { UnusedSkipTokenOptions } from '@tanstack/react-query'
import BankTransactionService from '../../services'

export const querySearchUsersForRematchOptions = (
	payload: SearchUsersForRematchParams,
	options?: UnusedSkipTokenOptions<SearchUsersForRematchResponse>,
) => ({
	queryKey: [TransactionQueryKeys.SEARCH_USERS_FOR_REMATCH, payload],
	queryFn: () => BankTransactionService.searchUsersForRematch(payload),
	enabled: !!payload.smsLogId,
	...options,
})
